var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.91C.004 1.174 10.608-3.32 17.016 2.876l-.013.032a9.827 9.827 0 0 1 2.913 7.009c-.003 7.54-8.133 12.266-14.721 8.708l-4.56 1.189a.43.43 0 0 1-.522-.53l1.216-4.418A9.858 9.858 0 0 1 0 9.91zM9.976 1.64c-6.51 0-10.458 7.15-7.022 12.62l.199.313-.806 2.926a.067.067 0 0 0 .081.083l3.013-.784s.567.33.702.4c5.453 2.832 12.103-1.101 12.108-7.308 0-2.2-.862-4.276-2.424-5.825a8.22 8.22 0 0 0-5.851-2.425zm-4.208 3.96c.31-.323.66-.329 1.14-.288.154 0 .36-.06.56.425.21.49.706 1.714.77 1.84.06.123.103.26.02.435-.466.88-.976.94-.732 1.362.147.25.643 1.062 1.383 1.725.95.85 1.753 1.113 2.003 1.237.247.113.392.101.538-.062.144-.165.622-.722.787-.968.236-.355 2.268.617 2.268.617.25.113.413.175.475.288.063.112.063.6-.15 1.187-.208.588-1.202 1.113-1.68 1.188-.429.062-.972.09-1.567-.1-2.203-.757-3.408-1.302-5.67-4.262-1.15-1.622-1.49-3.147-.145-4.625z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.cb456a1b310951f137cb13f12d1e3a95.svg";
export { ForwardRef as ReactComponent };